export default __webpack_public_path__ + "static/media/4.846bed23.png";